import { Box } from '@bonanza-social/moonlight';
import FooterLinks from './FooterLinks/FooterLinks';

function Footer() {
  return (
    <Box
      backgroundColor="bonanzaCarouselBackground"
      padding={{
        desktop: 'space-1000',
        tablet: 'space-1000',
        mobile: 'space-400',
      }}
      paddingTop={{
        desktop: 'space-2000',
        tablet: 'space-2000',
        mobile: 'space-1000',
      }}
      paddingBottom={{
        desktop: 'space-2000',
        tablet: 'space-2000',
        mobile: 'space-2000',
      }}
    >
      <Box
        gap="space-600"
        flexDirection={{
          desktop: 'row',
          tablet: 'row',
          mobile: 'column',
        }}
        flexWrap="wrap"
        justifyContent="center"
        width="100%"
      >
        <FooterLinks />
      </Box>
    </Box>
  );
}

export default Footer;
